module.exports = __webpack_public_path__ + "static/media/shambala.6b36cd90.png";